import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Table, Breadcrumb, Grid, Header, Button, Icon, Segment, Card, GridColumn } from 'semantic-ui-react';
import { utils } from '../../../helpers/utils';
import { JobSeekerData } from './useRegisteredJobSeekers';

type RegisteredJobSeekersProps = {
    listData: JobSeekerData[];
    handleDelete: Function;
    handleExport: Function;
    disabled?: boolean;
    isListLoading?: boolean;
    limitedHeight?: boolean;
}

export const RegisteredJobSeekers: React.FC<RegisteredJobSeekersProps> = ({ listData, handleDelete, handleExport, disabled = false, isListLoading = false, limitedHeight = false }) => {
    const history = useHistory();

    const cardDom = useRef();

    const hasData: boolean = listData.length > 0;

    return (
        <Segment basic loading={isListLoading} style={{ padding: 0 }}>
            <Grid>
                <Grid.Row style={{ padding: 0, position: 'relative' }}>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                        <span><b>{hasData ? `${listData.length} ` : 'No '} Job {hasData && listData.length > 1 ? 'seekers' : 'seeker'} registered for this workshop</b></span>
                        {
                            hasData &&
                            <div className='registered-job-seeks-table-delete-icon'>
                                <Button icon type='button' onClick={() => { handleExport() }} size='small'>
                                    <Icon name='file excel outline' />
                                    Download
                                </Button>
                            </div>
                        }
                    </Grid.Column>
                </Grid.Row>
                {
                    hasData &&
                    <Grid.Row>
                        <GridColumn mobile={16} tablet={16} computer={16}>
                            <div style={
                                limitedHeight ?
                                    { width: '100%', maxHeight: '22rem', overflowY: 'scroll', border: '1px solid lightgrey', borderRadius: '4px' }
                                    : {}
                                }>
                                <Table celled fixed singleLine striped>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Name</Table.HeaderCell>
                                            <Table.HeaderCell>Email</Table.HeaderCell>
                                            <Table.HeaderCell>Phone</Table.HeaderCell>
                                            {
                                                !disabled && hasData &&
                                                <Table.HeaderCell style={{ width: '43px' }}> </Table.HeaderCell>
                                            }
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {
                                            !hasData &&
                                            <Table.Row>
                                                <Table.Cell colSpan={(!disabled && hasData) ? 4 : 3}>
                                                    No data available
                                                </Table.Cell>
                                            </Table.Row>
                                        }
                                        {
                                            hasData &&
                                            listData.map((item, index) => {
                                                return (<Table.Row key={index}>
                                                    <Table.Cell>{item.name}</Table.Cell>
                                                    <Table.Cell>{item.email}</Table.Cell>
                                                    <Table.Cell>{utils.formatPhoneNumber(item.phoneNumber)}</Table.Cell>
                                                    {
                                                        !disabled &&
                                                        <Table.Cell><Icon title='Click to delete this job seeker'
                                                            onClick={() => {
                                                                handleDelete(item.workshopRegistrationId);
                                                            }}
                                                            name='trash' style={{ color: 'red', cursor: 'pointer' }}></Icon></Table.Cell>
                                                    }
                                                </Table.Row>);
                                            })

                                        }

                                    </Table.Body>
                                </Table>
                            </div>
                        </GridColumn>
                    </Grid.Row>
                }


            </Grid>
        </Segment>
    );
}